import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { buildApiUrl } from '../utils/api';

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setMensagem("Por favor, informe um e-mail válido.");
      return;
    }

    setLoading(true);
    setMensagem("");

    try {
      //const response = await fetch(buildApiUrl('/api/newsletter'), {
      const response = await fetch(buildApiUrl('/api/lead'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, name }),
      });

      if (response.ok) {
        setMensagem("✅ E-mail cadastrado com sucesso!");
        setEmail("");
      } else {
        const errorData = await response.json();
        setMensagem(errorData.message || "❌ Erro ao cadastrar o e-mail.");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      setMensagem("❌ Erro ao conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="w-full max-w-lg mx-auto p-4 xs:p-5 sm:p-6 bg-white shadow-md 
                 rounded-lg xs:rounded-xl mt-8 min-w-0"
    >
      <motion.h2
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="text-lg xs:text-xl xs2:text-xl xs3:text-2xl sm:text-2xl 
                  md:text-3xl font-bold text-gray-800 mb-3 xs:mb-4 text-center"
      >
        Inscreva-se na nossa Newsletter
      </motion.h2>
      <p className="text-gray-600 text-xs xs:text-sm sm:text-base mb-4 text-center">
        Receba promoções e novidades exclusivas no seu e-mail.
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 w-full">
        <input
          type="text"
          placeholder="Digite seu nome"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="flex-1 min-w-0 input-modern"
          required
          aria-label="Nome"
        />
        <input
          type="email"
          placeholder="Digite seu e-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 min-w-0 input-modern"
          required
          aria-label="E-mail"
        />
        <button
          type="submit"
          disabled={loading}
          className={`shrink-0 px-4 xs:px-5 sm:px-6 py-2.5 xs:py-3 rounded-lg 
                    text-white font-medium transition-all whitespace-nowrap
                    text-xs xs:text-sm sm:text-base ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-accent-500 to-accent-600 hover:from-accent-600 hover:to-accent-700 shadow-medium hover:shadow-large"
          }`}
        >
          {loading ? (
            <>
              <svg className="animate-spin h-4 w-4 xs:h-5 xs:w-5 inline-block mr-2" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              Enviando...
            </>
          ) : (
            "Inscrever"
          )}
        </button>
      </form>

      <AnimatePresence>
        {mensagem && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className={`mt-3 text-xs xs:text-sm font-medium flex items-center gap-2 ${
              mensagem.includes("✅") ? "text-green-600" : "text-red-600"
            }`}
          >
            <span>{mensagem.includes("✅") ? "✅" : "❌"}</span>
            {mensagem.replace(/[✅❌]/g, "").trim()}
          </motion.p>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default NewsletterForm;

